/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";

/** @module core/modules/array-utils/flatten */

/**
 * @description Reduces input array to a single level array.
 * @param {(Array<(Array<*>|*)>)} array - Input array.
 * @returns {Array<*>} Flattened array.
 */
function flatten(array) {
  var output = [];
  var length = array.length;
  var index = 0;

  while (index < length) {
    if (_Array$isArray(array[index])) {
      output = _concatInstanceProperty(output).call(output, flatten(array[index]));
    } else {
      output.push(array[index]);
    }

    index++;
  }

  return output;
}

export { flatten };